<nb-layout>
    <nb-layout-header fixed>
      <div class="col-11" style="display: flex; align-items: center;">
        <img src="assets/images/hit2open Inverted Color (1).png" width="205px" height="75px" style="cursor: pointer; "
          [routerLink]="role === 'chain_manager' ? ['/my-chains'] : ['/dashboard']">
        <nb-icon icon="menu-outline" style="text-align: start; width: 2em; margin-left: 10px;" class="iconDisplay"
          (click)="toggle()">Toggle</nb-icon>
      </div>
      <div class="col-1" style="display: flex; justify-content: center; align-items: center; ">
        <app-call-status-badge></app-call-status-badge>
        <div class="lang-toggle-header">
          <button [class.active]="currentLang === 'en'" (click)="setLanguage('en')">EN</button>
          <span>|</span>
          <button [class.active]="currentLang === 'da'" (click)="setLanguage('da')">DA</button>
        </div>
        <p class="sub-heading navText" (click)="onLogout()">{{ 'HEADER.LOGOUT' | translate }}</p>
      </div>
    </nb-layout-header>
  
    <nb-sidebar class="left" tag="left" start responsive="true">
  
    <nb-menu [items]="menu" tag="leftSideBar">
      <nb-icon icon="instagram" pack="font-awesome" class="custom-icon-style"></nb-icon>

    </nb-menu>

    <div class="app-version">
      <span *ngIf="adminCommit">Admin: {{ adminCommit }}</span>
      <span *ngIf="apiCommit"> · API: {{ apiCommit }} · {{ apiBuildDate }}</span>
    </div>
  </nb-sidebar>
  
    <nb-layout-column class="colored-column-warning" style="background-color: #F5F5F5;">
      <div class="twofa-warning-banner" *ngIf="show2FAWarning">
        <div class="twofa-warning-content">
          <nb-icon icon="shield-off-outline" class="twofa-warning-icon"></nb-icon>
          <span>
            <strong>{{ 'HEADER.TWO_FA_BANNER' | translate }}</strong>
            {{ 'HEADER.TWO_FA_BANNER_LINK' | translate }}
          </span>
        </div>
        <div class="twofa-warning-actions">
          <a [routerLink]="['/security-settings']" class="twofa-enable-link">{{ 'HEADER.ENABLE_2FA' | translate }}</a>
          <nb-icon icon="close-outline" class="twofa-dismiss" (click)="dismissWarning()" [title]="'HEADER.DISMISS' | translate"></nb-icon>
        </div>
      </div>
      <router-outlet></router-outlet>
    </nb-layout-column>
  </nb-layout>
